import SelectField from "../../../../components/form-fields/select-field/select-field";
import classNames from "classnames";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-field";
import { isSomething } from "../../../../utils/utils";
import { Delete } from "../../../../utils/svg-components";
import DummyField from "../../../../components/dummy-field/dummy-field";

export const DEFAULT_OPTION_SELECT = {
  label: "Senior Account Director",
  value: "Senior Account Director",
};
export const ResourcesColumn = ({
  usersOptions,
  rolesOptions,
  removeRole,
  updateResource,
  rateOption,
  fetchedRolesList,
  loggedRolesList,
}) => {
  return [
    {
      name: "Roles",
      dataKey: "role",
      width: "30%",
      align: "left",
      render: (cellData, rowData, i) => {
        const updatedOptions = [
          ...rolesOptions,
          ...(isSomething(cellData)
            ? [
                {
                  label: cellData,
                  value: cellData,
                  category: fetchedRolesList[cellData]?.serviceGroup,
                },
              ]
            : []),
        ];

        return (
          <div
            className={classNames({
              "role-data": true,
              noEvent: cellData && loggedRolesList?.includes(cellData),
            })}
          >
            <div onClick={() => removeRole(rowData?.id)} className="icon-btn">
              <Delete />
            </div>

            <SelectField
              placeholder="Please Select Role"
              value={cellData}
              options={updatedOptions}
              isGrouped
              onChange={(event) => {
                updateResource(rowData?.id, "role", event.target.value);
              }}
            />
          </div>
        );
      },
    },

    {
      name: "Assignee(s)",
      dataKey: "assignees",
      width: "60%",
      align: "left",
      render: (cellData, rowData) => {
        const isRoleSelected = !!rowData?.role;        
        return (
          <div className="cell-padding">
            <SelectField
              isGrouped
              multiple
              closeOnSelect
              options={usersOptions?.filter((x) => x?.employmentStatus === "Active")}
              value={cellData}
              disabled={!isRoleSelected}
              onCrossClick={(select) => {
                const filtered = cellData?.filter((x) => x !== select);
                updateResource(rowData?.id, "assignees", filtered);
              }}
              onChange={(event) => {
                updateResource(rowData?.id, "assignees", event.target.value);
              }}
            />
          </div>
        );
      },
    },

    {
      name: "Rate ($)",
      dataKey: "rate",
      width: "10%",
      align: "left",
      render: (cellData, rowData, i) => {
        const isDisabled = rateOption === "flat" && i >= 0;
        return (
          <div className="rate">
            <TextInputField
              value={cellData}
              inputType={"number"}
              disabled={isDisabled}
              onChange={(event) => {
                updateResource(rowData?.id, "rate", event.target.value);
              }}
            />
          </div>
        );
      },
    },
  ];
};

export const ResourcesColumnCollapse = ({
  rolesOptions,
  fetchedRolesList,
  loggedRolesList,
}) => {
  return [
    {
      name: "Roles",
      dataKey: "role",
      width: "40%",
      align: "left",
      render: (cellData, rowData, i) => {
        const updatedOptions = [
          ...rolesOptions,
          ...(isSomething(cellData)
            ? [
                {
                  label: cellData,
                  value: cellData,
                  category: fetchedRolesList[cellData]?.serviceGroup,
                },
              ]
            : []),
        ];

        return (
          <div
            className={classNames({
              "role-data collapse": true,
              noEvent: cellData && loggedRolesList?.includes(cellData),
            })}
          >
            <DummyField value={cellData} />
          </div>
        );
      },
    },
  ];
};
